export default __webpack_public_path__ + "static/Aclimacao-15499f70fdc614b044106c64dfc66c7a.svg";